import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[datepickerToggle]'
})
export class DatepickerToggleDirective {

  @Input('target') target: string;

  @HostListener('click') onClick() {

    const tgt = document.querySelector(this.target);
    if (tgt) {
      tgt['focus']();
    }

  }

  constructor() {
  }

}
